import { render, staticRenderFns } from "./EditableListItem.vue?vue&type=template&id=8590528e&"
import script from "./EditableListItem.vue?vue&type=script&lang=js&"
export * from "./EditableListItem.vue?vue&type=script&lang=js&"
import style0 from "./EditableListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports